import { jsx as _jsx } from "react/jsx-runtime";
import { DefaultButton } from '@fluentui/react';
/**
 * A button that allows users to skip to the main content of the page.
 */
export const SkipToContentButton = ({ name = 'Skip to main content', }) => {
    const mainContentElement = document.getElementById('main-content');
    if (mainContentElement === null) {
        return null;
    }
    return (_jsx(DefaultButton, Object.assign({ styles: {
            root: {
                display: 'block',
                width: 0,
                position: 'absolute',
                bottom: '4px',
                top: '4px',
                right: '4px',
                left: '4px',
                opacity: 0,
                height: '40px',
                minWidth: '122px',
                ':focus': {
                    width: 'unset',
                    opacity: 0.95,
                },
                zIndex: 1,
            },
        }, href: '#main-content', text: name }, { children: name })));
};
